import Spinner from "@/components/Spinner/Spinner.vue";
import { mapGetters, mapActions } from "vuex";
import authService from "@/services/auth";
import { ALERT_TYPES } from "@/constants/variables";
import Utils from "@/mixins/Utils";
import SectionTitle from "@/components/SectionTitle/SectionTitle.vue";
import {COMPONENT_KEYWORD} from '@/constants/variables'
import documentService from "@/services/document";
export default {

  data() {
    return {
      email: this.$route.query.email || "",
      password: "",
      alert: {},
      createAdvPassword: (/true/i).test(this.$route.query.isCreation),
      newAdvEmail: "",
      confirmPassword: "",
      token: this.$route.query.token || "",
      isInvalidToken: undefined,
      showPassword: false,
      showConfirmPassword: false,
      isValidatedFailed: false,
      questionImgUrl: '',
      refuseImgUrl: '',
      confirmImgUrl:'',
      isValidatedSuccess: false,
      deeplink: process.env.VUE_APP_DEEP_LINK_URL,
    };
  },
  mixins: [Utils],
  components: {
    Spinner,
    SectionTitle,
  },
  computed: {
    ...mapGetters("auth", {
     generalSetting:"generalSetting"
    }),
    ...mapGetters({
      errorMessage: "errorMessage",
      loadingSpinner: "isLoading",
      successMessage: "successMessage",
    }),
    passwordLengthValid() {
      return this.password.length >= 8;
    },
    passwordUppercaseValid() {
      return /[A-Z]/.test(this.password);
    },
    passwordNumberValid() {
      return /\d/.test(this.password);
    },
    passwordSpecialValid() {
      return /[^A-Za-z0-9]/.test(this.password);
    },
    allPasswordValid() {
      return (
        this.passwordLengthValid &&
        this.passwordUppercaseValid &&
        this.passwordNumberValid &&
        this.passwordSpecialValid
      );
    },
    passwordInputState() {
      if (!this.password) return null;
      return this.allPasswordValid ? 'valid' : 'invalid';
    },
    isAccountCreationUnavailable() {
      // Example: show this page if token is invalid or any error occurs
      return this.isInvalidToken === true ;
    },
    unavailableTitle() {
      return this.createAdvPassword === false ? this.$t('reset-pwd-token-expired-title') : this.$t('account-creation-unavailable-website-title');
    },
    unavailableContent() {
      return this.createAdvPassword === false ? this.$t('reset-pwd-token-expired-content') : this.$t('account-creation-unavailable-website-content');
    },
    contactUsLabel() {
      return this.createAdvPassword === false ? this.$t('error-contact-us-button') : this.$t('account-creation-error-contact-us-button');
    },
    isCheckTheSamePassword() {
      // Only check if both fields have values
      return !this.confirmPassword || this.password === this.confirmPassword;
    },
    isFormValid() {
      return (
        this.password &&
        this.confirmPassword &&
        this.allPasswordValid &&
        this.isCheckTheSamePassword
      );
    },
  },
  created() {
    if (this.token) {
      authService
        .checkAdvNewPasswordToken(this.token)
        .then((res) => {
          if (!res.success) {
            this.isInvalidToken = true;
            this.getQuestionImage();
            this.getRefuseImage();
            this.getConfirmImage();
          } else {
            this.isInvalidToken = false;
            this.getRefuseImage();
            this.getConfirmImage();
          }
        })
        .catch((err) => {
          this.isInvalidToken = true;
          this.getQuestionImage();
          this.getRefuseImage();
          this.getConfirmImage();
          console.log('err',err);
        });
    }
  },
  methods: {
       getQuestionImage() {
           documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.QUESTION_IMAGE_WEB}).then((res)=> {
              if(res && res.components) {
               this.questionImgUrl = res.components && res.components.length > 0 ? res.components.find(component => component.appName === '2').urlFile : '';
     
              }
           })
        },
        getRefuseImage() {
           documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.REFUSED_IMAGE_WEB}).then((res)=> {
              if(res && res.components) {
               this.refuseImgUrl = res.components && res.components.length > 0 ? res.components.find(component => component.appName === '2').urlFile : '';
     
              }
           })
        },
        getConfirmImage() {
           documentService.getComponentBykeyword({keyword:COMPONENT_KEYWORD.CONFIRMATION_REQUEST_IMAGE_WEB}).then((res)=> {
              if(res && res.components) {
               this.confirmImgUrl = res.components && res.components.length > 0 ? res.components.find(component => component.appName === '2').urlFile : '';
     
              }
           })
        },
     contactUsLink() {
      // Get from MBO config or fallback
      if (this.generalSetting && this.generalSetting.signupContactRedirectUrl) {
      return this.generalSetting.signupContactRedirectUrl;
      }
    
    },
    openContactUsLink() {
      const url = this.contactUsLink();
      window.open(url, "_blank");
    },
    showSuccessModal() {
      this.$refs["my-modal"].show();
    },
    onCancel() {
      this.onSetAlert(false);
      this.$refs["my-modal"].hide();
      this.$router.push('/public/default/connexion');
    },
    onchangePassword(event) {
      this.hasCapital = false;
      this.hasLowerCase = false;
      this.hasNumber = false;
    },

    updateRecoverPassword() {
      const data = {
        password: this.password,
      };      

      authService
        .checkAdvNewPasswordToken(this.token)
        .then((res) => {
          if (!res.success) {
            this.isInvalidToken = true;
          } else {
            this.isInvalidToken = false;
            this.isValidatedSuccess = false;
            this.isValidatedFailed = false;
            authService
              .updateRecoveryPassword(data, false, this.token)
              .then((res) => {
                if (res.success) {
                  this.isValidatedFailed = false;
                  this.isValidatedSuccess = true;
                } else {
                  this.isValidatedFailed = true;
                  this.isValidatedSuccess = false;
                }
              })
              .catch((err) => {
                this.isValidatedFailed = true;
                this.isValidatedSuccess = false;
              });
          }
        })
        .catch((err) => {
          this.isInvalidToken = true;
        });
    },
    onSetAlert(isShow, variantType, msg) {
      this.alert = {
        variant: variantType,
        message: msg,
        show: isShow,
      };
    },
    togglePassword(field) {
      if (field === 'password') {
        this.showPassword = !this.showPassword;
      } else if (field === 'confirmPassword') {
        this.showConfirmPassword = !this.showConfirmPassword;
      }
    },
    handleSuccessButton() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if( this.isValidatedFailed) {
        // If the validation failed, restart the account creation process
        this.isValidatedFailed = false;
        this.isValidatedSuccess = false;
        this.isInvalidToken = false;
        return;
      }
      
      if (isMobile) {
        // Try to open the app
        window.location.href = window.configs && window.configs.VUE_APP_SCHEMA_URL 
          ? window.configs.VUE_APP_SCHEMA_URL : process.env.VUE_APP_SCHEMA_URL;

        // If the app is not installed, after a delay, redirect to the store
        setTimeout(() => {
          if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            window.location.href = window.configs && window.configs.VUE_APP_APPLE_APP_URL 
              ? window.configs.VUE_APP_APPLE_APP_URL : process.env.VUE_APP_APPLE_APP_URL;
          } else if (/Android/i.test(navigator.userAgent)) {
            window.location.href = window.configs && window.configs.VUE_APP_ANDROID_APP_URL 
              ? window.configs.VUE_APP_ANDROID_APP_URL : process.env.VUE_APP_ANDROID_APP_URL;
          }
        }, 1500);
      } else {
        // On PC, redirect to the ADV Web login screen
        this.$router.push('/public/default/connexion');
      }
    },
  },
  watch: {
    isInvalidToken(newVal) {
      if (newVal === true) {
        // Focus password input when the form becomes visible
        this.$nextTick(() => {
          if (this.$refs.passwordInput) {
            this.$refs.passwordInput.focus();
          }
        });
      }
    }
  },
};
